var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.246 8.292a.93.93 0 00-.81-.28.94.94 0 00-.82.27l-14.34 14.35a1 1 0 000 1.38 1 1 0 00.71.29 1 1 0 00.71-.29l13.74-13.71 13.74 13.71a1 1 0 001.41 0 1 1 0 000-1.41l-14.34-14.31z"
  })));
}

export default SvgClose;